import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: triggered from drupal brand-specific analytics.js
const defaultData: IDataLayer = {
  filterProducts: {
    event_category: 'filter & sort selection',
    event_action: 'filter',
    event_name: 'filter'
  },
  sortClick: {
    event_name: 'filters_and_sort_selection',
    event_category: 'filter & sort selection',
    event_action: null, // <sort_page>,
    event_label: null // <store_option>
  }
};

function trackProductFilterSort(eventName: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};

  eventData.event_label = eventData.sort_option?.toLowerCase();
  eventData.event_action =
    data.page_type === 'search' ? ['sort - ' + data.page_type] : 'sort - PLP';

  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackProductFilterSort);
});
